/**
 * Renders an individual industries card displaying information about an industry.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.image - The URL of the image representing the industry.
 * @param {string} props.heading - The heading/title of the industry.
 * @param {string} props.detail1 - The first detail point about the industry.
 * @param {string} props.detail2 - The second detail point about the industry.
 * @param {string} props.detail3 - The third detail point about the industry.
 * @param {string} props.detail4 - The fourth detail point about the industry.
 * @returns {JSX.Element} - The rendered industries card.
 */

const IndustriesCard = (props) => {
  return (
    <div className='item'>
      <div className='serviceIndustries-items'>
        <div id='Industries' className='owl-carousel'>
          {props.image && <img src={props.image} alt='' className='w-100' />}
          <div className='industries-items-textBox'>
            {props.heading && <b>{props.heading}</b>}
            <ul>
              {props.detail.map(
                (detailView, index) =>
                  detailView && <li key={index}>{detailView}</li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndustriesCard;
